export const nothing = null;

export type Nothing = null;
